import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000/api',
});

const clearSessionAndRedirect = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('role');
  localStorage.removeItem('username');

  if (window.location.pathname !== '/') {
    window.location.href = '/';
  }
};

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginEndpoint = error.config?.url?.includes('/auth/login');
    const status = error.response?.status;

    if ((status === 401 || status === 403) && !isLoginEndpoint) {
      clearSessionAndRedirect();
    }

    return Promise.reject(error);
  }
);

export default api;
